import { render, staticRenderFns } from "./CategoryPosts.vue?vue&type=template&id=bdbfc316&scoped=true&lang=pug&"
import script from "./CategoryPosts.vue?vue&type=script&lang=js&"
export * from "./CategoryPosts.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPosts.vue?vue&type=style&index=0&id=bdbfc316&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbfc316",
  null
  
)

/* custom blocks */
import block0 from "./CategoryPosts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports